import { useTranslations } from 'next-intl';
import { useState } from 'react';
import '@/src/components/Accordion.css';
import { MdArrowForwardIos } from 'react-icons/md';

export default function ShippingInfo() {
  const t = useTranslations('ShippingInfo');
  const [active, setActive] = useState(false);

  const handleToggle = () => {
    setActive(!active);
  };
  return (
    <div className='flex flex-col p-4 text-dark bg-brand-dark rounded'>
      <button
        onClick={() => handleToggle()}
        aria-expanded={active}
        className={`accordion-trigger block w-full pr-10 text-left lg:cursor-default`}
      >
        <h3 className='font-bold'>{t('title')}</h3>
        <span className='accordion-state lg:!hidden'>
          <MdArrowForwardIos />
        </span>
      </button>
      <div className='accordion-content lg:!grid-rows-1' aria-hidden={!active}><div><div className='pt-2'>{t('text')}</div></div></div>
    </div>
  );
}
